import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { AGENCY_POSTING_INIT_LOADING, AGENCY_POSTING_INIT_SUCCESS, AGENCY_POSTING_INIT_FAIL } from '@/store/types'

export const post = {
  async agencyQuotePostInit({ commit, state }) {
    // reset quotation state (prevent dirty data)
    if (state.posting.init !== 1) {
      const apiUrl = state.menu.posting
      if (apiUrl) {
        commit(AGENCY_POSTING_INIT_LOADING)
        try {
          const result = await http.get(apiUrl)
          const menu = extractMenu(result.data._links)
          const commitResult = {
            menu: menu
          }
          commit(AGENCY_POSTING_INIT_SUCCESS, commitResult)
        } catch (error) {
          commit(AGENCY_POSTING_INIT_FAIL, extractMessages(error))
        }
      } else {
        commit(AGENCY_POSTING_INIT_FAIL, ['Invalid API URL'])
      }
    }
  }
}
